export default __webpack_public_path__ + "static/media/btechWave1.fe85d3a6.png";